import { useCallback, useState, type Dispatch, type SetStateAction } from 'react'
import { Toast } from '@/components/Toast'
import classRecordApi from '../api'
import { idKey } from '../helpers'
import { ClassRecord } from '../types'

type UseClassRecordRecordActionsOptions = {
  setRecords: Dispatch<SetStateAction<ClassRecord[]>>
}

export function useClassRecordRecordActions({ setRecords }: UseClassRecordRecordActionsOptions) {
  const [noteDraftMap, setNoteDraftMap] = useState<Record<string, string>>({})
  const [noteSavingMap, setNoteSavingMap] = useState<Record<string, boolean>>(
    {},
  )

  const handleNoteBlur = useCallback(
    async (record: ClassRecord) => {
      const key = idKey(record.id)
      const draft = noteDraftMap[key]
      if (draft === undefined) {
        return
      }

      const nextNote = draft.trim()
      const originalNote = (record.note || '').trim()
      if (nextNote === originalNote) {
        return
      }

      try {
        setNoteSavingMap((prev) => ({ ...prev, [key]: true }))
        await classRecordApi.update(record.id, { note: nextNote })
        setRecords((prev) =>
          prev.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  note: nextNote,
                }
              : item,
          ),
        )
        Toast.success('备注已保存')
      } catch (error) {
        Toast.error('保存备注失败')
        console.error('保存备注失败:', error)
      } finally {
        setNoteSavingMap((prev) => ({ ...prev, [key]: false }))
      }
    },
    [noteDraftMap, setRecords],
  )

  const resetRecordActionDrafts = useCallback(() => {
    setNoteDraftMap({})
  }, [])

  return {
    noteDraftMap,
    setNoteDraftMap,
    noteSavingMap,
    handleNoteBlur,
    resetRecordActionDrafts,
  }
}
